var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "v-row",
          { class: "mt-4" },
          [
            _c("v-col", { attrs: { cols: "12", sm: "6", md: "6" } }, [
              _c(
                "div",
                [
                  _vm.selectedFolder != null
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mr-4",
                          attrs: { outlined: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.updateDialogDocuments(true)
                            },
                          },
                        },
                        [_vm._v("Nuevo Documento")]
                      )
                    : _vm._e(),
                  _vm.selectedFolder === null ||
                  _vm.selectedFolder.legajo != null
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.updateDialog(true)
                            },
                          },
                        },
                        [_vm._v("Crear Carpeta")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c(
              "v-col",
              {
                staticClass: "justify-end align-end d-flex",
                attrs: { cols: "12", sm: "6", md: "6" },
              },
              [
                _c("v-text-field", {
                  attrs: {
                    "append-icon": "mdi-magnify",
                    label: "Buscar",
                    dense: "",
                    outlined: "",
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "v-row",
          { staticClass: "mt-0" },
          [
            _c(
              "v-col",
              { attrs: { cols: "12", md: "12" } },
              [
                _c("Breadcrumbs", {
                  attrs: {
                    navigationStack: _vm.navigationStack,
                    selectedFolder: _vm.selectedFolder,
                  },
                  on: {
                    "reset-navigation": _vm.resetNavigation,
                    "go-to-folder": _vm.goToFolder,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        !_vm.selectedFolder
          ? _c("ListFolder", {
              attrs: {
                folders: _vm.filteredFoldersView,
                loading_folders: _vm.loading_folders,
                legajo_id: _vm.legajo_id,
              },
              on: {
                "open-folder": _vm.openFolder,
                editItem: _vm.editItem,
                deleteItem: _vm.deleteItem,
              },
            })
          : _c("ListFile", {
              attrs: {
                folderData: _vm.filteredFoldersView,
                loading_folders: _vm.loading_folders,
                legajo_id: _vm.legajo_id,
              },
              on: {
                "go-back": _vm.goBack,
                "open-folder": _vm.openFolder,
                editItem: _vm.editItem,
                deleteItemFile: _vm.deleteItemFile,
                deleteItem: _vm.deleteItem,
              },
            }),
        _c("ModalFolder", {
          attrs: {
            modal_title: "Carpeta",
            formBtn: _vm.formBtn,
            dialog: _vm.dialog,
            service: _vm.service,
            item: _vm.mainItem,
            selectedFolder: _vm.selectedFolder,
          },
          on: {
            updateDialog: _vm.updateDialog,
            loadList: _vm.loadList,
            updateItem: (newItem) => {
              _vm.mainItem = newItem
            },
          },
        }),
        _c("ModalAddDocuments", {
          attrs: {
            modal_title: "Subir Documentos",
            formBtn: _vm.formBtn,
            dialog: _vm.dialog_documents,
            service: _vm.documentLegajoService,
            item: _vm.mainItem,
            selectedFolder: _vm.selectedFolder,
            legajo_id: _vm.legajo_id,
          },
          on: {
            updateDialog: _vm.updateDialogDocuments,
            loadList: _vm.loadList,
            updateItem: (newItem) => {
              _vm.mainItem = newItem
            },
          },
        }),
        _c("DialogDelete", {
          attrs: {
            dialog_delete: _vm.dialog_delete,
            text:
              "¿Esta seguro que quiere eliminar la carpeta " +
              _vm.mainItem.name +
              "?",
            subtext: "Al borrar se borrara los archivos dentro de esta carpeta",
          },
          on: {
            updateDialogDelete: _vm.updateDialogDelete,
            deleteItemConfirm: _vm.deleteItemConfirm,
          },
        }),
        _c("DialogDelete", {
          attrs: {
            dialog_delete: _vm.dialog_delete_file,
            text:
              "¿Esta seguro que quiere eliminar el archivo " +
              _vm.mainItemFile.name +
              "?",
          },
          on: {
            updateDialogDelete: _vm.updateDialogDeleteFile,
            deleteItemConfirm: _vm.deleteItemConfirmFile,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }